import { AnnouncementDetailPage } from '@/components/announcements/announcement-detail-page'

export function MemberAnnouncementDetail() {
  return <AnnouncementDetailPage basePath="/announcements" />
}
